import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs';
import { AlertService } from '../services/alert.service';
import { DataStoreService } from '../services/data-store.service';
import { AppConstants } from '../entities/app-constants';


@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  refreshTokenInProgress = false;
  refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  dataStoreService = inject(DataStoreService);
  cloud: string;
  constructor(
    private authService: AuthService, 
    private alertService: AlertService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (
      !request.url.includes('.s3.') &&
      !request.url.includes('.blob.') &&
      !request.url.includes(environment.mstrURL)
    ) {
      request = this.setAuthToken(request);
    }

    return next.handle(request).pipe(
      catchError(error => {
        if (request.url.includes('refresh-token') || request.url.includes('login')) {
          this.conditionCheckAuth(request);

          return throwError(error);
        }

        const message = error?.error?.message || 'Bad request error occurred';

        if ([400, 403].includes(error.status)) {
          this.alertService.error(message);
        }

        if (error.status !== 401) {
          return throwError(() => error);
        }

        if (this.refreshTokenInProgress) {
          return this.refreshTokenSubject.pipe(
            filter(token => token !== null),
            take(1),
            switchMap(_token => next.handle(this.setAuthToken(request)))
          );
        } else {
          this.refreshTokenInProgress = true;

          this.cloud = this.dataStoreService.getData('cloud');
          if(!this.cloud) console.error(AppConstants.cloudProviderError);
          
          return this.authService.refreshToken(this.cloud).pipe(
            switchMap((token: any) => {
              //When the call to refreshToken completes we reset the refreshTokenInProgress to false
              // for the next time the token needs to be refreshed
              this.refreshTokenInProgress = false;
              this.refreshTokenSubject.next(token);

              return next.handle(this.setAuthToken(request));
            }),
            catchError((err: any) => {
              if (!err.url.includes(environment.mstrURL)) {
                this.refreshTokenInProgress = false;
                this.authService.logout();
              } else {
                this.alertService.error(`Failed to connect ${environment.mstrURL}`);
              }
              return throwError(error);
            })
          );
        }
      })
    );
  }
  conditionCheckAuth(request) {
    if (request.url.includes('refresh-token')) {
      this.authService.logout();
    }
  }
  setAuthToken(request) {
    //     return request.clone({
    //   headers: request.headers.set('Authorization', `Bearer ${this.authService.getToken()}`)
    // });
    return request
    // .clone({
    //   headers: request.headers.set('Authorization', `Bearer ${this.authService.getToken()}`)
    // });
  }
}
